import React from 'react';

export const sriLankanAgreement  = () => (
  <div className="host-agreement-wrapper"  style={{
    backgroundColor: '#f5f5f5', // light gray
    padding: '10px',
    borderRadius: '8px',
  }}>
    {/* <h3>MillionSpaces Host Summary Agreement</h3> */}

    <section>
      <h4><strong>Scope:</strong></h4>
      <p>
        This agreement allows hosts to list their spaces on the MillionSpaces platform under the following categories:
      </p>
      <ul>
        <li><strong>Work:</strong> Individual Workspaces, Private Offices</li>
        <li><strong>Meet:</strong> Meeting Rooms, Boardrooms, Interview Rooms, Team Building, Training Spaces</li>
        <li><strong>Shoot:</strong> Photo and Video Shoot Locations</li>
      </ul>
    </section>

    <section>
    <h4><strong>Commission Structure:</strong></h4>
      <p>
        MillionSpaces charges a fixed commission of <strong>15%</strong> on each confirmed booking across all categories. This applies to the total booking value (excluding taxes and incidentals) and is deducted before the host receives payment.
      </p>
    </section>

    <section>
    <h4><strong>Booking & Payments:</strong></h4>
      <ul>
        <li>MillionSpaces manages bookings and payment collection from guests.</li>
        <li>Payouts (after commission deduction) are made to the host within 14 working days after the booking becomes non-cancellable.</li>
        <li>Guests can cancel as per site policy. In such cases, cancellation fees (if any) will be paid in full to the host.</li>
      </ul>
    </section>

    <section>
      <h4><strong>Host Responsibilities:</strong></h4>
      <ul>
        <li>Keep listings, availability calendars, pricing, and details updated.</li>
        <li>Ensure spaces meet quality standards shown in photos.</li>
        <li>Provide access to spaces as booked, and maintain them in good condition.</li>
        <li>Avoid undercutting prices or taking direct bookings to bypass the platform.</li>
      </ul>
    </section>

    <section>
      <h4><strong>MillionSpaces Responsibilities:</strong></h4>
      <ul>
        <li>List and promote your space on the platform.</li>
        <li>Handle customer service and booking communications.</li>
        <li>Provide booking details including guest info and timing.</li>
        <li>Ensure the platform remains secure and functional.</li>
      </ul>
    </section>

    <section>
      <h4><strong>Term:</strong></h4>
      <p>
        The agreement is valid for <strong>12 months</strong> and auto-renews annually unless terminated with <strong>30 days’ written notice</strong>.
      </p>
    </section>
  </div>
);
